import type { ReactNode } from 'react';
import { memo } from 'react';

import cn from 'classnames';

import { HelpPopover } from '@/shared/cms/question-mark';

import cls from './title-with-help.module.css';

export interface TitleWithHelpProps {
    title: ReactNode;
    helpId?: string | undefined;
    size?: 'md' | 'lg';
    className?: string | undefined;
}

export const TitleWithHelp = memo(
    ({ title, helpId, size = 'md', className }: TitleWithHelpProps) => (
        <div className={cn(cls.titleWrapper, className)}>
            <span className={cn(cls.title, cls[size])}>{title}</span>
            {helpId && <HelpPopover helpId={helpId} />}
        </div>
    ),
);

TitleWithHelp.displayName = 'TitleWithHelp';
